import { useInstantSearch } from 'react-instantsearch';
import algoliaIndexes from '@klv/organisms/unified-search/data';

const useAlgoliaHits = () => {
  // get the scoped results & query
  const { scopedResults } = useInstantSearch();

  try {
    // Check if we have mixed cached data (different hitsPerPage values)
    const hitsPerPageValues = scopedResults
      .map(({ results }) => results?.hitsPerPage)
      .filter(Boolean);
    
    let hasMixedCacheData = hitsPerPageValues.length > 1 && 
      new Set(hitsPerPageValues).size > 1;

    const indexSet = new Set(scopedResults.map(({ indexId }) => indexId));
    const hasAllResourcesIndexResults =
      indexSet.has(algoliaIndexes.allResourcesIndex) &&
      indexSet.has(algoliaIndexes.communitIndex);

    if (hasAllResourcesIndexResults) {
      // We should only be getting back results from the commingled index and community. 
      // IF we get more than two results we have a bug — the previous index is being included in the results. 
      // This bug occurs when switching between indexes.. There is an additional API call being made to Algolia,
      // including the previous index and current (newly selected) index.
       hasMixedCacheData = hitsPerPageValues.length > 2;
    }
        
    if (hasMixedCacheData) {
      return { totalHits: 0, hitsDisplayed: 0, hasStaleHits: true };
    }

    const totalHits = scopedResults.reduce((acc, { results }) => {
      if (results) {
        return acc + results.nbHits;
      }
      return acc;
    }, 0);
    
    const hitsDisplayed = scopedResults.reduce((acc, { results }) => {
      if (results) {
        if (results.nbPages === results.page + 1) {
          return acc + results.nbHits;
        } else {
          if (results.nbHits >= results.hitsPerPage) {
            return acc + (results.page + 1) * results.hitsPerPage;
          } else {
            return acc + results.nbHits;
          }
        }
      }
      return acc;
    }, 0);

    return { totalHits, hitsDisplayed };
  } catch (e) {
    return { totalHits: 0, hitsDisplayed: 0 };
  }
};

export default useAlgoliaHits;
